const selectors = {
  calloutTab: '[data-hotspot-tab]',
  callouts: '[data-hotspot-callout]',
  calloutsContainer: '[data-callouts-container]',
  hotspotSection: '[data-product-hotspost]',
};

const dom = {};

const cacheDom = () => {
  dom.hotspotSection = document.querySelectorAll(selectors.hotspotSection);
};

const onTabChange = (tab, allTabs, allCallouts) => {
  const tabIndex = tab.dataset.hotspotTab;

  allTabs.forEach((tab) => {
    tab.classList.remove('active');
  });

  allCallouts.forEach((callout) => {
    callout.classList.remove('active');

    if (callout.dataset.hotspotCallout == tabIndex) {
      callout.classList.add('active');
    }
  });

  tab.classList.add('active');
};

const handleHotspotEvents = () => {
  if (dom.hotspotSection) {
    dom.hotspotSection.forEach((hotSpot) => {
      const thisHotSpot = hotSpot;
      const thisCallouts = thisHotSpot.querySelectorAll(selectors.callouts);
      const thisCalloutsContainer = thisHotSpot.querySelector(
        selectors.calloutsContainer,
      );
      const thisCalloutTabs = thisHotSpot.querySelectorAll(
        selectors.calloutTab,
      );

      thisCalloutTabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          onTabChange(tab, thisCalloutTabs, thisCallouts);
        });
      });
    });
  }
};

const productHotspot = {
  init() {
    cacheDom();
    handleHotspotEvents();
  },
};

export default productHotspot;
